<template>
  <common-card title="Progress (!!! still working on !!!)">
    <el-steps direction="vertical" :active="status">
      <el-step :title="ShipmentWorking">
        <template v-slot:description>
          <div class="f-c" style="gap: 10px;">
            <!-- stage port -->
            <div class="progress-item f-r-vc">
              <svg-icon
                icon-class="check"
                v-if="hasStageNo"
                class="progress-complete svg-success-color"
              />
              <svg-icon
                icon-class="warning"
                v-else
                class="progress-complete svg-danger-color"
              />
              <span v-if="hasStageNo">Stage Port is {{ stageNo }}</span>
              <span v-else>Stage Port is required</span>
            </div>
            <!-- how many pallets are at stage port -->
            <div class="progress-item f-r-vc">
              <i
                class="el-icon-loading progress-working"
                v-if="preparedPalletCount < palletCount"
              />
              <svg-icon
                icon-class="check"
                v-else
                class="progress-complete svg-success-color"
              />
              <span v-if="preparedPalletCount < palletCount">
                Staged {{ preparedPalletCount }} / {{ palletCount }} pallets
              </span>
              <span v-else> All pallets are at stage port! </span>
            </div>
            <!-- pick up date -->
            <div class="progress-item f-r-vc">
              <svg-icon
                icon-class="check"
                v-if="hasPickUpDate"
                class="progress-complete svg-success-color"
              />
              <svg-icon
                icon-class="warning"
                v-else
                class="progress-complete svg-danger-color"
              />
              <span v-if="hasPickUpDate">Pick Up Date is {{ pickUpDate }}</span>
              <span v-else>Pick up date required</span>
            </div>
            <!-- how many pallets are loaded -->
            <div class="progress-item f-r-vc">
              <i
                class="el-icon-loading progress-working"
                v-if="preparedPalletCount < palletCount"
              />
              <svg-icon
                icon-class="check"
                v-else
                class="progress-complete svg-success-color"
              />
              <span v-if="loadedPalletCount < palletCount">
                Loaded {{ loadedPalletCount }} / {{ palletCount }} pallets
              </span>
              <span v-else> All pallets are loaded! </span>
            </div>
            <!-- seal no -->
            <div class="progress-item f-r-vc">
              <svg-icon
                icon-class="check"
                v-if="hasSealNo"
                class="progress-complete svg-success-color"
              />
              <svg-icon
                icon-class="warning"
                v-else
                class="progress-complete svg-danger-color"
              />
              <span v-if="hasSealNo">Seal No is {{ sealNo }}</span>
              <span v-else>Seal No is required</span>
            </div>
          </div>
        </template>
      </el-step>
      <el-step :title="ShipmentShipping"></el-step>
      <el-step :title="ShipmentDelivered"></el-step>
    </el-steps>
  </common-card>
</template>
<script>
import CommonCard from '@/components/common/CommonCard.vue'
import {
  ShipmentWorking,
  ShipmentShipping,
  ShipmentDelivered
} from '@/core/models/shipment'
import { PalletOnStage } from '@/core/models/pallet'
import { transferDbDate } from '@/core/utils/date'
export default {
  name: 'ShipmentProgress',
  props: {
    shipment: {
      type: Object,
      required: true
    },
    pallets: {
      type: Array,
      default: () => []
    },
    jobs: {
      type: Array,
      default: () => []
    }
  },
  components: {
    CommonCard
  },
  data() {
    return {
      ShipmentWorking,
      ShipmentShipping,
      ShipmentDelivered
    }
  },
  computed: {
    status() {
      const status = this.shipment.status
      return status === ShipmentWorking
        ? 0
        : status === ShipmentShipping
          ? 2
          : status === ShipmentDelivered
            ? 3
            : -1
    },
    shipmentStatus() {
      return this.shipment.status
    },
    palletCount() {
      return this.shipment.palletIds.length
    },
    pickUpDate() {
      return transferDbDate(this.shipment.pickUpDate)
    },
    hasPickUpDate() {
      return this.pickUpDate !== '' && this.pickUpDate != null
    },
    stageNo() {
      return this.shipment.stageNo
    },
    hasStageNo() {
      return this.stageNo !== '' && this.stageNo != null
    },
    dockNo() {
      return this.shipment.dockNo
    },
    hasDockNo() {
      return this.dockNo !== '' && this.dockNo != null
    },
    preparedPalletCount() {
      if (this.shipmentStatus === ShipmentShipping) return this.pallets.length
      return this.pallets.filter(p => p.status === PalletOnStage).length
    },
    loadedPalletCount() {
      return this.shipment.loadedPalletIds.length
    },
    sealNo() {
      return this.shipment.sealNo
    },
    hasSealNo() {
      return this.sealNo !== '' && this.sealNo != null
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.progress-item {
  gap: 10px;

  span {
    font-size: 16px;
  }

  svg,
  i {
    font-size: 16px;
  }
}

.progress-complete {
  color: $el-success-color;
}

.progress-working {
  color: $business-color;
}

.progress-required {
  color: $el-danger-color;
}
</style>
